// 改造工事費用算定
const DR_SIDE_KOJI_COSTLIST = 'DR_SIDE_KOJI_COSTLIST';
const DR_SIDE_KOJI_COSTID = 'DR_SIDE_KOJI_COSTID';
const DR_SIDE_KOJI_COSTDETAIL = 'DR_SIDE_KOJI_COSTDETAIL';

export default {
  /* 改造工事費用算定一覧 */
  DR_SIDE_KOJI_COSTLIST: DR_SIDE_KOJI_COSTLIST,

  /* 改造工事費用算定ID */
  DR_SIDE_KOJI_COSTID: DR_SIDE_KOJI_COSTID,

  /* 改造工事費用算定詳細 */
  DR_SIDE_KOJI_COSTDETAIL: DR_SIDE_KOJI_COSTDETAIL,
};

